import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-search-target',
    templateUrl: './cp-search-target.component.html',
    styleUrls: ['./cp-search-target.component.scss'],
    encapsulation: ViewEncapsulation.None 
})
export class CPSearchTargetComponent {
    constructor() {

    }
    @Input() canClear: boolean = true;
    @Input() readOnly: boolean = false;
    @Input() value: string;
    @Input() code: string;
    @Input() searchMode: number = 1; //1=passive, 2=active 
    @Input() showAction: boolean;
    @Input() showSearch: boolean;
    @Input() searchText: string = "Search...";
    @Input() vehicleExpenseTransfer: boolean = false;
    @Output() search: EventEmitter<string> = new EventEmitter<string>();
    @Output() goto: EventEmitter<any> = new EventEmitter<any>(); 
    @Output() validate: EventEmitter<string> = new EventEmitter<any>();  // This is an output component that tells the rest of the world that the user has entered a valid text
    @Output() keyPress: EventEmitter<any> = new EventEmitter<any>();  // This is an output component that tells the rest of the world that the user has entered a valid text
    @Input() required: boolean = false;

    get hasValue(): boolean {
        return CommonFunctions.hasValue(this.value);
    }
    public onSearchType(value: string, e: any) {
        if (this.searchMode == 2) {
            this.doSearch();
        }
        else {
            console.log("cp-s->onST: ", e, value);
            this.keyPress.emit({ e, value})
        }
    }
    searchClick() {
        if (this.searchMode == 2) {
            this.doSearch();
        }
    }
    doSearch() {
        if (!this.readOnly) {
            this.search.emit(this.value);
        }
    }
    clear(e: any) {
        this.value = "";
        if (e) {
            e.stopPropagation();
        }
        this.search.emit("CLEAR");
    }
    public action(e: any, code: string) {
        console.log("cp-srch-targ:", e, this.value, code);
        if (e) {
            e.stopPropagation();
        }
        if (code === "GOTO") {
            this.goto.emit(this.value);
        }
        else if (code === "SEARCH") {
            this.doSearch();
        }
        else if (code === "CLEAR") {
            this.clear(null);
        }
    }
    onBlurMethod(e: any) {
        if (!this.readOnly) {

            setTimeout(function () {
                var target = document.activeElement;
                // this.validate.emit(this.value);
                //document.getElementById("focused").value =
                //    target ? target.id || target.tagName || target : '';
            }, 1);
            this.validate.emit(this.value);
        }
    }
}
